import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as PageActions from '../actions/pages.action';
import { switchMap, map, catchError, tap, withLatestFrom } from 'rxjs/operators';
import { PagesService } from '../../services';
import { Store } from '@ngrx/store';
import { getActiveLanguageNoCulture } from '@teamfoster/sdk/language-ngrx';

@Injectable()
export class PagesEffects {
  constructor(private actions$: Actions, private service: PagesService, private store: Store) {}

  LoadPages$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PageActions.LoadPages),
      withLatestFrom(this.store.select(getActiveLanguageNoCulture)),
      switchMap(([{}, lang]) =>
        this.service.getPages(lang).pipe(
          map(pages => PageActions.LoadPagesSuccess({ pages })),
          catchError(error => of(PageActions.LoadPagesFail({ error })))
        )
      )
    );
  });

  LoadPageByHandle$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PageActions.LoadPageByHandle),
      withLatestFrom(this.store.select(getActiveLanguageNoCulture)),
      switchMap(([{ handle }, lang]) =>
        this.service.getPageByHandle(handle, lang).pipe(
          map(page => PageActions.LoadPageByHandleSuccess({ page })),
          catchError(error => of(PageActions.LoadPageByHandleFail({ error })))
        )
      )
    );
  });
}
